import React from "react"
import IcdByInvestor from "./icdByInvestor"
import IcdByAdmin from "./icdByAdmin"

const IcdSearchResult = ({ data, close }) => {
  return (
    <>
      {data?.data?.icdsByInvestor?.length > 0 && (
        <IcdByInvestor data={data.data.icdsByInvestor} close={close} />
      )}

      {data?.data?.icdsByAdmin?.length > 0 && (
        <IcdByAdmin data={data.data.icdsByAdmin} close={close} />
      )}
    </>
  )
}

export default IcdSearchResult
